import styled from 'styled-components';
import Button from '../../../atoms/Button';
export var Field = styled(Button).withConfig({
  displayName: "style__Field",
  componentId: "sc-vr922b-0"
})(["height:3rem;&&{margin:1rem;}"]);